import * as React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import Stacked from "./Layouts/Stacked";
import Overlayed from "./Layouts/Overlayed";

const Layouts = {
  default: Overlayed,
  stacked: Stacked,
};

export const Tile = ({
  data,
  layout = "default",
  height,
  settings,
}) => {
  const LayoutComponent = Layouts[layout];
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  return <LayoutComponent data={data} height={height} settings={settings} isMobile={isMobile} />;
};

export default Tile;
